import { getStorageItem, setStorageItem } from './storage';

export interface CacheEnvelope<T> {
  data: T;
  cachedAt: number;
  userId: string;
}

export type LoadSource = 'network' | 'cache' | 'empty';

export const OFFLINE_CACHE_KEYS = {
  catalog: (userId: string) => `gym-cache:${userId}:catalog`,
  routines: (userId: string) => `gym-cache:${userId}:routines`,
  workouts: (userId: string) => `gym-cache:${userId}:workouts`,
  plans: (userId: string) => `gym-cache:${userId}:plans`,
  queue: (userId: string) => `gym-queue:${userId}`,
  queueLock: (userId: string) => `gym-queue-lock:${userId}`,
} as const;

export async function writeCache<T>(key: string, data: T, userId: string): Promise<void> {
  const envelope: CacheEnvelope<T> = {
    data,
    cachedAt: Date.now(),
    userId,
  };
  await setStorageItem(key, JSON.stringify(envelope));
}

export async function readCache<T>(key: string, userId: string): Promise<T | null> {
  const raw = await getStorageItem(key);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as CacheEnvelope<T>;
    if (!parsed || parsed.userId !== userId) return null;
    return parsed.data ?? null;
  } catch {
    return null;
  }
}
